module.exports = __webpack_public_path__ + "static/media/hall-CSE.73fc2099.svg";